const style = {
  container: {
    outer: {
      sm: 'w-[94px]',
      md: 'w-[183px]',
      lg: 'w-[272px]',
    },
    inner: {
      sm: 'h-[2.5rem] w-[2.5rem]',
      md: 'h-[5rem] w-[5rem]',
      lg: 'h-[7.5rem] w-[7.5rem]',
    },
  },
  diamond: {
    sm: 'h-[calc(1.75rem+2px)] w-[calc(1.75rem+2px)]',
    md: 'h-[3.5rem] w-[3.5rem]',
    lg: 'h-[5.25rem] w-[5.25rem]',
    inner: {
      sm: 'border-[2.5px] rounded-md',
      md: 'border-[5px] rounded-lg',
      lg: 'border-[7.5px] rounded-xl',
    },
    outer: {
      sm: 'border-[4.5px] rounded-md',
      md: 'border-[9px] rounded-lg',
      lg: 'border-[13.5px] rounded-xl',
    },
  },
  text: {
    sm: 'text-[1.5rem] mt-[-3.8px] ml-[13.3px] space-y-[-4px]',
    md: 'text-[3rem] mt-[-6.5px] ml-[26.3px] space-y-[-10px]',
    lg: 'text-[4.5rem] mt-[-10px] ml-[39.3px] space-y-[-15px]',
  },
};

export type QbLogoSize = keyof typeof style.text;

type Props = {
  size?: QbLogoSize;
};

const QbLogoFullName = ({ size = 'sm' }: Props) => {
  return (
    <div
      className={`${style.container.outer[size]} flex items-center justify-start`}
    >
      <div
        className={`${style.container.inner[size]} relative flex items-center justify-center`}
      >
        <div
          className={`${style.diamond[size]} ${style.diamond.outer[size]} absolute rotate-[-5deg] scale-105 border-orange-400`}
        />
        <div
          className={`${style.diamond[size]} ${style.diamond.inner[size]} absolute rotate-[51deg] border-orange-500 bg-orange-400`}
        />
        <div className={`relative block h-full w-full -skew-x-6 italic`}>
          <div
            className={`${style.text[size]} font-bold leading-none text-white`}
          >
            <div className="ml-[0.5px]">
              qui
              <span className="text-orange-400">z</span>
              <span className="text-orange-400">z</span>y
            </div>
            <div className="ml-[-0.5px]">
              boo
              <span className="text-orange-400">z</span>e
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QbLogoFullName;
